export type ProcessProject = {
  id: number
  name: string
  description?: string | null
  position: number
  process_count?: number
  document_count?: number
  lock_version: number
}

export function filterProjects(projects: ProcessProject[], query: string): ProcessProject[] {
  const term = query.trim().toLowerCase()
  const ordered = [...projects].sort((a, b) => a.position - b.position || a.name.localeCompare(b.name))
  if (!term) return ordered
  return ordered.filter((project) => `${project.name} ${project.description || ''}`.toLowerCase().includes(term))
}
